
export class Reminder {

    constructor() {
        this.orderKey = 0;
        this.reminderRepeat = ReminderRepetition["Bez ponavljanja"];
        this.reminderRepeatEnd = ReminderRepetitionEnd["Bez prestanka"];
        this.isCompleted = false;
    }

    id?: number;
    name?: string;
    image?: string;
    orderKey: number;
    reminderTime?: Date;
    reminderRepeat: ReminderRepetition;
    reminderRepeatEnd: ReminderRepetitionEnd;
    repetitionEndDate?: Date;
    repetitionOccurrenceCount?: number;
    currentRepetitionOccurrenceCount?: number;
    isCompleted: boolean;

    
    public get isGlobal(): boolean {
        return this.userId == null;
    }
    
    userId?: number;
}


export enum ReminderRepetition {
    'Bez ponavljanja' = 0,
    'Dnevno' = 1,
    'Tjedno' = 2,
    'Mjesečno' = 3,
    'Godišnje' = 4,
    'Radnim danom' = 5
}

export enum ReminderRepetitionEnd {
    'Bez prestanka' = 0,
    'Nakon određenog broja ponavljanja' = 1,
    'Krajnji datum' = 2,
}